import styled from '@emotion/styled';
import { ifProp } from 'styled-tools';
import { Link, StyledResetButton } from '~/shared/components';
import { preserveFontSize } from '~/shared/utils/styled';
import { breakpoints } from '~/theme';

export const StyledContainer = styled.div(() => ({
    // Content is client rendered so we set a min height to avoid layout shift
    minHeight: '100vh',
}));

export const StyledContent = styled.div(() => ({
    p: {
        maxWidth: '80ch',
    },
}));

export const StyledMenuLink = styled(Link)<{
    bold?: boolean;
    disabled?: boolean;
    content?: string;
    hidden?: boolean;
}>(
    ({ bold, content }) => ({
        fontWeight: bold ? 'bold' : 'inherit',
        ...preserveFontSize(content),
    }),
    ifProp('disabled', () => ({
        pointerEvents: 'none',
        opacity: 0.3,
    }))
);

export const StyledOrderHistoryLink = styled(StyledMenuLink)(({ theme }) => ({
    [breakpoints.md]: {
        marginTop: theme.spaces[4],
        paddingTop: theme.spaces[4],
        borderTop: `1px solid ${theme.colors.light30}`,
    },
}));

export const StyledInactiveContent = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    gap: theme.spaces[3],
    maxWidth: '65ch',
}));

export const StyledMenuButton = styled(StyledResetButton)(({ theme }) => ({
    fontSize: theme.fontSizes['lg'],
}));
